import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";

export default function OtherSkills({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">{t("Other Skills")}</legend>
      <input
        name="otherSkills"
        onChange={onChange}
        value={searchObject.otherSkills || ""}
        className="form-control fontsize-legend"
      />
    </div>
  );
}
